<script>
export default {
    name: 'DsIllustration',

    props: {
        /**
         * The name of the illustration.
         */
        name: {
            type: String,
            default: '',
        },

        /**
         * The size variant. This will be used to determine the size of the illustration.
         */
        size: {
            type: String,
            default: 'medium',
            validator: (size) => ['small', 'medium', 'large', 'mega'].includes(size),
        },
    },

    computed: {
        imageSize() {
            if (this.size === 'small') {
                return '48';
            }

            if (this.size === 'medium') {
                return '72';
            }

            if (this.size === 'large') {
                return '96';
            }

            if (this.size === 'mega') {
                return '144';
            }

            return this.size;
        },
    },

    render(h) {
        const {
            name,
            imageSize,
        } = this;

        if (!name) {
            return null;
        }

        if (this.$designSystem.useNewIllustrations) {
            let Illustration;

            const normalizedName = name.replace(/(-color|-gray)$/, '');

            try {
                Illustration = require(`../../assets/images/illustrations-new/${normalizedName}.svg`).default;
            } catch (e) {
                Illustration = require('../../assets/images/illustrations-new/not-found.svg').default;
            }

            return h(Illustration, {
                attrs: {
                    viewBox: '0 0 48 48',
                    height: imageSize,
                    width: imageSize,
                },
            });
        }

        const Illustration = require(`../../assets/images/illustrations/${name}.svg`).default;

        return h(Illustration, {
            attrs: {
                viewBox: '0 0 120 100',
            },
        });
    },
};
</script>
